import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClickOutsideDirective } from '../directives/click-outside/click-outside.directive';
import { AutofocusDirective } from '../directives/autofocus/autofocus.directive';
import { ImageDirective } from '../directives/image/image.directive';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/modules/material.module';
import { TimepickerComponent } from '../directives/timepicker/timepicker.component';
import { DateInputDirective } from '../directives/date-input/date-input.directive';
import { TimeInputDirective } from '../directives/time-input/time-input.directive';
import { AppIdleTimeoutDirective } from '../directives/app-idle/app-idle-timeout.directive';
import { DisableButtonDirective } from '../directives/disableButton/disableButton.directive';
import { AppTooltipDirective } from '../directives/tooltip/app-tooltip.directive';


@NgModule({
  imports: [
    CommonModule,
    NgxMaskDirective,
    NgxMaskPipe,
    FormsModule,
    MaterialModule,
    AppTooltipDirective    
  ],
  declarations: [
    ClickOutsideDirective,
    AutofocusDirective,
    ImageDirective,
    TimepickerComponent,
    DateInputDirective,
    TimeInputDirective,
    AppIdleTimeoutDirective,
    DisableButtonDirective,    
  ],
  exports: [
    ClickOutsideDirective,
    AutofocusDirective,
    ImageDirective,
    TimepickerComponent,
    DateInputDirective,
    TimeInputDirective,
    AppIdleTimeoutDirective,
    DisableButtonDirective,
    AppTooltipDirective
  ],
  providers: [  provideNgxMask() ]

})
export class DirectivesModule { }
